/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Hi-Voltage custom code (ported from Venue 11 to Venue 18, Oct 2026).
// Data comes from snippets/hv-product-data.liquid (window.productTags, window.hvVariantInventory).

/* 1) Quantity limit: don't let shoppers pick more than we have in stock. */
function hvCurrentVariantId() {
  var idInput = document.querySelector('form[id^="product-form-"] input[name="id"]');
  return idInput ? idInput.value : null;
}

function hvMaxQty() {
  var inv = window.hvVariantInventory;
  var id = hvCurrentVariantId();
  if (!inv || !id || !inv[id]) return null;
  var v = inv[id];
  if (!v.managed || v.policy === 'continue' || v.qty <= 0) return null;
  return v.qty;
}

function hvClamp(input) {
  var max = hvMaxQty();
  if (max && parseInt(input.value, 10) > max) input.value = max;
}

function enforceQuantityLimit() {
  document.querySelectorAll('quantity-input').forEach(function (component) {
    if (component.dataset.hvLimited) return;
    var input = component.querySelector('input[name="quantity"]');
    if (!input) return;
    component.dataset.hvLimited = 'true';
    var plusBtn = component.querySelector('[plus]');
    if (plusBtn) plusBtn.addEventListener('click', function () { setTimeout(function () { hvClamp(input); }, 0); });
    input.addEventListener('change', function () { hvClamp(input); });
    input.addEventListener('input', function () { hvClamp(input); });
  });
}

document.addEventListener('DOMContentLoaded', enforceQuantityLimit);

/* 2) PRE-ORDER button: yellow button + release date for products tagged with a future bMMDDYY / MMDDYY date. */
function handlePreorderButton() {
  if (!window.productTags) return;

  var tags = window.productTags.map(function (t) { return String(t).toLowerCase(); });
  var today = new Date();
  today.setHours(0, 0, 0, 0);

  var releaseDateStr = null;
  var releaseDate = null;

  for (var i = 0; i < tags.length; i++) {
    var tag = tags[i];
    if (/^b\d{6}$/.test(tag)) tag = tag.slice(1);
    if (/^\d{6}$/.test(tag)) {
      var mm = tag.slice(0, 2);
      var dd = tag.slice(2, 4);
      var yy = '20' + tag.slice(4, 6);
      releaseDate = new Date(parseInt(yy, 10), parseInt(mm, 10) - 1, parseInt(dd, 10));
      releaseDateStr = mm + '/' + dd + '/' + yy;
      break;
    }
  }

  if (!releaseDate || releaseDate <= today) return;

  var addBtn = document.querySelector('.product-single button[name="add"], button[name="add"]');
  if (!addBtn) return;

  addBtn.style.setProperty('--button-background-color', '#f5c518');
  addBtn.style.setProperty('--button-hover-background-color', '#e0b200');
  addBtn.style.setProperty('--color--btn', '#000');
  addBtn.style.backgroundColor = '#f5c518';
  addBtn.style.color = '#000';
  addBtn.style.borderColor = '#f5c518';

  var btnText = addBtn.querySelector('.staged-action__text, .js-product-add-text');
  if (btnText && addBtn.disabled !== true) btnText.textContent = 'PRE-ORDER';

  if (!document.querySelector('.preorder-release-date')) {
    var dateEl = document.createElement('p');
    dateEl.className = 'preorder-release-date';
    dateEl.style.cssText = 'color:#cc0000;font-weight:700;margin-top:8px;font-size:14px;letter-spacing:0.05em;';
    dateEl.textContent = 'RELEASE DATE: ' + releaseDateStr;
    var wrap = addBtn.closest('.product-form__add') || addBtn.parentElement;
    wrap.appendChild(dateEl);
  }
}

document.addEventListener('DOMContentLoaded', handlePreorderButton);
